module.exports = require('./shippingConfig/kaizen');
